import { Tag } from 'antd';
import moment from 'moment'

// eslint-disable-next-line no-unused-vars
function onClickEvent (status, activate, cancel, record) {
  // 未激活
  if (status === 0) {
    activate(record);
  } else {
    cancel(record); 
  }
}

function createColumns (activate, cancel) {
  
  const columns = [
    {
      title: 'QuoteId',
      dataIndex: 'quoteId',
    },
    {
      title: 'OrderName',
      render: (data) => {
        return data['OrderModel']['name']
      },
      width: 150,
    },
    {
      title: 'User Email',
      dataIndex: 'email',
    },
    {
      title: 'Country',
      dataIndex: 'country',
    },
    {
      title: 'Product Name',
      dataIndex: 'productName',
    },
    {
      title: 'product Id',
      dataIndex: 'productId',
    },
    {
      title: 'Variant title',
      dataIndex: 'variantTitle',
    },
    {
      title: 'Variant Id',
      dataIndex: 'variantId',
    },
    {
      title: 'update time',
      dataIndex: 'updatedAt',
      render: (data) => {
        return moment(data).format('YYYY-MM-DD HH:mm:hh')
      }
    },
    {
      title: 'Status',
      dataIndex: 'state',
      render: (state) => {
        if (state === '0' || state === 0) {
          return <Tag color="#108ee9">Pending</Tag>
        } else if (state === '1' || state === 1) {
          return <Tag color="#2db7f5">quote</Tag>
        } else if (state === '2' || state === 2){
          return <Tag color="#87d068">hand off</Tag>
        }
      }
    }
  ];
  return columns;
}

export default createColumns;